module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Juvie-Classroom_BW-p-500-e6d8a10bf8384623eac2ee5047a4346c.jpg";